import { useAutorun } from '@speedlo/hooks'
import { observable } from 'mobx'
import * as R from 'ramda'
import { IAccount, paths, SegmentKey } from 'shopify-payment-core'

import { useFirebaseQuery } from './useFirebaseQuery'

const accounts = observable.map<ID, IAccount>()

export const useAccountMap = (segmentKey: SegmentKey = 'gopay') => {
  const result = useFirebaseQuery<Dictionary<IAccount>>(
    paths[segmentKey].accounts,
    { subscribe: true },
  )
  useAutorun(() => {
    if (!result.loading) {
      accounts.replace(R.toPairs(result.data!))
    }
  })
  return [accounts, result.loading && accounts.size === 0] as [
    typeof accounts,
    boolean
  ]
}
